import { dataBaseService } from "@/services/DataBaseService";
import { makeAutoObservable, runInAction } from "mobx";

class DataBaseStore {
  private _waitingStatusDBConnected: boolean = true;
  private _success: boolean = false;
  private _message: string = "";

  constructor() {
    makeAutoObservable(this);
  }

  get messageError(): string {
    return this._message;
  }

  get successError(): boolean {
    return this._success;
  }

  async DBStatus() {
    runInAction(() => {
      this._waitingStatusDBConnected = true;
    });

    try {
      const result = await dataBaseService.getDBStatus();
      console.log(result);

      runInAction(() => {
        this._waitingStatusDBConnected = false;
        this._success = result.success;
        this._message = result.message;
      });
    } catch (e) {
      const message = e instanceof Error ? e.message : typeof e === "string" ? e : "Unknown error";
      runInAction(() => {
        this._waitingStatusDBConnected = false;
        this._success = false;
        this._message = message;
      });
    }
  }

  dbConnected(): void {
    this.DBStatus();
  }

  get waitingStatusDBConnected(): boolean {
    return this._waitingStatusDBConnected;
  }

  get message(): string {
    return this._message;
  }

  get success(): boolean {
    return this._success;
  }

  get errorCode(): string | undefined {
    return this.message;
  }
}

export const dataBaseStore = new DataBaseStore();
